import React from 'react'
import { connect } from 'react-redux'

import { GridList } from '@bikemap/components/GridList'
import { RouteTile } from '@bikemap/components/RouteTile'
import { ConnectedList } from '@bikemap/js/integrations/list'
import RouteGridItemContent from './RouteGridItemContent.jsx'
import NoResultsMessage from './NoResultsMessage.jsx'
import { DisruptorTile } from '@bikemap/components/DisruptorTile'
import { getImagePath } from '@bikemap/js/utility'
import { LANGUAGE } from '@bikemap/js/settings'
import { gettext } from '@bikemap/js/services'

const SearchResults = ({ highlight }) => {
    const disruptorTileProps = {
        url: 'https://bikemap.page.link/discover-app',
        imageUrl: getImagePath('search/disruptor' + (LANGUAGE === 'de' ? '-de.png' : '.png')),
        ctaText: gettext('Discover more routes in App'),
    }

    const renderList = ({ items, isQuerying, count }) => {
        const gridProps = {
            items,
            loading: isQuerying,
            count,
            highlight,
            renderItem: item => <RouteGridItemContent routeId={item} />,
            renderPlaceholder: () => <RouteTile />,
            renderDisruptor: () => <DisruptorTile {...disruptorTileProps} />,
        }

        return <GridList id="search-results-grid" {...gridProps} />
    }

    const renderNoResults = () => <NoResultsMessage />

    return <ConnectedList listKey="results" renderList={renderList} renderNoResults={renderNoResults} />
}

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ highlight }) => ({
    highlight,
})

export default connect(mapStateToProps)(SearchResults)
